module.exports = __webpack_public_path__ + "images/6892cfe80996909a8913cdced43f6e91.png";